import { render } from "./PublicationCard.vue?vue&type=template&id=2d6fc054"
import script from "./PublicationCard.vue?vue&type=script&lang=js"
export * from "./PublicationCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/cookiemonster/Isaac_Files/Ongoing_Projects/PersonalWebsite/personal_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__